import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function Redirect(props: { to: string }) {
    const navigate = useNavigate();

    useEffect(() => {
        navigate(props.to, { replace: true });
    }, [navigate, props.to]);

    return null;
}
